import { useState, useEffect } from "react";
import {Grid, FormControl, InputLabel, Select, MenuItem} from '@mui/material';



function ShoeSize(props) {

    const [shoeRegion, setShoeRegion] = useState('uk');
    const [shoeSize, setShoeSize] = useState(props.selectedItem.size);

    const handleShoeRegion = (event) => {
        setShoeRegion(event.target.value);
    };


    const handleShoeSize = (event) => {
        setShoeSize(event.target.value);
    };

    useEffect(() => {
        var shoe_data = {"region":shoeRegion, "size":shoeSize};
        props.handleChange(shoe_data);
    },[shoeRegion, shoeSize])

    var sizes = {};

    sizes["uk"] = [
        {"label": "1", "cm": "20.6"},
        {"label": "1.5", "cm": "21"},
        {"label": "2", "cm": "21.4"},
        {"label": "2.5", "cm": "21.8"},
        {"label": "3", "cm": "22.2"},
        {"label": "3.5", "cm": "22.6"},
        {"label": "4", "cm": "23"},
        {"label": "4.5", "cm": "23.4"},
        {"label": "5", "cm": "23.8"},
        {"label": "5.5", "cm": "24.2"},
        {"label": "6", "cm": "24.6"},
        {"label": "6.5", "cm": "25"},
        {"label": "7", "cm": "25.5"},
        {"label": "7.5", "cm": "26"},
        {"label": "8", "cm": "26.5"},
        {"label": "8.5", "cm": "27"},
        {"label": "9", "cm": "27.5"},
        {"label": "9.5", "cm": "28"},
        {"label": "10", "cm": "28.5"},
        {"label": "10.5", "cm": "29"},
        {"label": "11", "cm": "29.5"},
        {"label": "11.5", "cm": "30"},
        {"label": "12", "cm": "30.5"},
        {"label": "12.5", "cm": "31"},
        {"label": "13", "cm": "31.5"},
        {"label": "13.5", "cm": "32"},
        {"label": "14", "cm": "32.5"}
    ]

    sizes["eu"] = [
        {"label": "33", "cm": "20.6"},
        {"label": "34", "cm": "21.4"},
        {"label": "35", "cm": "22.2"},
        {"label": "36", "cm": "22.6"},
        {"label": "37", "cm": "23"},
        {"label": "38", "cm": "23.8"},
        {"label": "39", "cm": "24.6"},
        {"label": "40", "cm": "25"},
        {"label": "41", "cm": "25.5"},
        {"label": "41.5", "cm": "26"},
        {"label": "42", "cm": "26.5"},
        {"label": "42.5", "cm": "27"},
        {"label": "43", "cm": "27.5"},
        {"label": "43.5", "cm": "28"},
        {"label": "44", "cm": "28.5"},
        {"label": "44.5", "cm": "29"},
        {"label": "45", "cm": "29.5"},
        {"label": "45.5", "cm": "30"},
        {"label": "46", "cm": "30.5"},
        {"label": "46.5", "cm": "31"},
        {"label": "47", "cm": "31.5"},
        {"label": "47.5", "cm": "32"},
        {"label": "48", "cm": "32.5"}
    ];

    sizes["us"] = [
        {"label": "2", "cm": "20.6"},
        {"label": "2.5", "cm": "21"},
        {"label": "3", "cm": "21.4"},
        {"label": "3.5", "cm": "21.8"},
        {"label": "4", "cm": "22.2"},
        {"label": "4.5", "cm": "22.6"},
        {"label": "5", "cm": "23"},
        {"label": "5.5", "cm": "23.4"},
        {"label": "6", "cm": "23.8"},
        {"label": "6.5", "cm": "24.2"},
        {"label": "7", "cm": "24.6"},
        {"label": "7.5", "cm": "25"},
        {"label": "8", "cm": "25.5"},
        {"label": "8.5", "cm": "26"},
        {"label": "9", "cm": "26.5"},
        {"label": "9.5", "cm": "27"},
        {"label": "10", "cm": "27.5"},
        {"label": "10.5", "cm": "28"},
        {"label": "11", "cm": "28.5"},
        {"label": "11.5", "cm": "29"},
        {"label": "12", "cm": "29.5"},
        {"label": "12.5", "cm": "30"},
        {"label": "13", "cm": "30.5"},
        {"label": "13.5", "cm": "31"},
        {"label": "14", "cm": "31.5"},
        {"label": "14.5", "cm": "32"},
        {"label": "15", "cm": "32.5"}
    ]
    
    const display_sizes = sizes[shoeRegion].map((size) =>
        <MenuItem key={size.label} value={size.label} className={props.selectedItem.size === size.label ? "selected" : "list-item"}>{size.label}</MenuItem>
    );

    if(props.loadingState){
        return (
            <></>
        )
    }else{
        return (
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <InputLabel id="control-ssc-label">Shoe Size Region</InputLabel>
                        <Select
                            labelId="control-ssc-label"
                            id="control-ssc-select"
                            label="Shoe Size Region"
                            sx={{mb:2}}
                            onChange={handleShoeRegion}
                            value={shoeRegion}
                        >
                            <MenuItem key="uk" value="uk" className="list-item">UK</MenuItem>
                            <MenuItem key="eu" value="eu" className="list-item">EU</MenuItem>
                            <MenuItem key="us" value="us" className="list-item">US</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <InputLabel id="control-sss-label">Shoe Size</InputLabel>
                        <Select
                            labelId="control-sss-label"
                            id="control-sss-select"
                            label="Shoe Size"
                            sx={{mb:2}}
                            value={shoeSize}
                            onChange={handleShoeSize}
                            >
                            {display_sizes}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        );
    }
  }
  

  export default ShoeSize;